<app-header></app-header>
<app-nav-menu></app-nav-menu>
<main id="main" class="main">

  <div class="pagetitle">
    <h1>Manage Service Acccounts</h1>
    <nav>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
        <li class="breadcrumb-item active">Manage Service Accounts</li>
      </ol>
    </nav>
  </div>

  <section class="section dashboard">
    <div class="container bg-white overflow-auto">
      <div class="row">
        <div class="col-lg-12">
          <div>
            <button type="button" class="btn btn-primary btn-sm mt-3" data-bs-toggle="modal" data-bs-target="#submitAccessModal" (click)="clearValues()"><i class="bi bi-person-add me-1"></i> Add Service Account</button>
            &nbsp;<button type="button" class="btn btn-link mt-3"><i class="bi bi-info-circle"></i> How to Create Service Account on Google Cloud?</button>
          </div>
          <hr />
          <app-spinner *ngIf="showSpinner"></app-spinner>
          <table class="table table-hover" *ngIf="!showSpinner">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Custom Project Name</th>
                <th scope="col">Remaining Quota (Daily)</th>
                <th scope="col">Update</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" *ngIf="serviceAccounts.length==0">
                <td colspan="5">No records found.</td>
              </tr>
              <tr *ngFor="let serviceAccount of serviceAccounts; index as i">
                <th scope="row">{{i+1}}</th>
                <td>{{serviceAccount.projectName}}</td>
                <td>
                  <h6>{{serviceAccount.remainingDailyQuota}} / 200</h6>
                  
                  


                  <!--<div class="progress mt-3">
    <div class="progress-bar" role="progressbar" [ngStyle]="{'width': serviceAccount.remainingDailyQuota * 0.5 +'%'}" aria-valuenow="(serviceAccount.remainingDailyQuota * 0.5)" aria-valuemin="0" aria-valuemax="100">{{serviceAccount.remainingDailyQuota * 0.5}}%</div>
  </div>-->
                </td>
                <td><button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#submitAccessModal" (click)="openUpdateModal(serviceAccount)"><i class="bi bi-pencil"></i></button></td>
                <td><button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#deleteConfirmationModal" (click)="openDeleteModal(serviceAccount)"><i class="bi bi-trash"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</main>
<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

<app-generic-modal modalTitle="{{modalTitle}}" modalId="submitAccessModal">

  <form class="row g-3">
    <div class="col-lg-12">
      <div class="alert alert-info fade show" role="alert">
        <i class="bi bi-info-circle me-1"></i>
        Copy paste your service account JSON file's content where you generated on Google Cloud Console. Click <a href=""><b>here</b></a> to learn how to generate a service account JSON file.
      </div>
    </div>
    <div class="col-lg-12">
      <input type="text" class="form-control" placeholder="Project Name" [(ngModel)]="projectName" name="projectName">
    </div>
    <div class="col-lg-12">
      <textarea class="form-control" name="serviceAccountJson" [(ngModel)]="serviceAccountJson" style="height: 450px" placeholder="Example JSON file:
{
  &quot;type&quot;: &quot;service_account&quot;,
  &quot;project_id&quot;: &quot;xxxxx-xxxx-xxxx&quot;,
  &quot;private_key_id&quot;: &quot;xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx&quot;,
  &quot;private_key&quot;: &quot;-----BEGIN PRIVATE KEY-----
[REDACTED]
-----END PRIVATE KEY-----
&quot;,
  &quot;client_email&quot;: &quot;xxxxx@xxxxx-xxxx-xxxx.iam.gserviceaccount.com&quot;,
  &quot;client_id&quot;: &quot;xxxxxxxxxxxxxxxxx&quot;,
  &quot;auth_uri&quot;: &quot;https://accounts.google.com/o/oauth2/auth&quot;,
  &quot;token_uri&quot;: &quot;https://oauth2.googleapis.com/token&quot;,
  &quot;auth_provider_x509_cert_url&quot;: &quot;https://www.googleapis.com/oauth2/v1/certs&quot;,
  &quot;client_x509_cert_url&quot;: &quot;https://www.googleapis.com/robot/v1/metadata/x509/xxxxx-xxxx-xxxx.iam.gserviceaccount.com&quot;,
  &quot;universe_domain&quot;: &quot;googleapis.com&quot;
}"></textarea>
    </div>
  </form>

  <button class="btn btn-primary float-end mt-2" (click)="addOrUpdateServiceAccount()">Submit</button>
</app-generic-modal>

<app-generic-modal modalTitle="Delete Service Account" modalId="deleteConfirmationModal" modalSize="modal-sm">
  <p>Are you sure you want to delete this service account?</p>
  <button class="btn btn-danger float-end mt-2" (click)="deleteServiceAccount()">Delete</button>
  <button type="button" class="btn btn-secondary float-end m-2" data-bs-dismiss="modal">Cancel</button>
</app-generic-modal>

<app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
</app-alert>
